import React from 'react';
import { withRouter } from 'react-router-dom';
import { e4Format, e4Formats } from 'helpers/dates';
import { SystemText } from '@salesperformanceint/e4shared';
import posthog from 'posthog-js';

export const FocusTile = ({
    tileType,
    colour,
    icon,
    message,
    messageTwo,
    url,
    date,
    buttonText = 'View',
    setShow,
    history,
}) => {
    return (
        <div className={`tile ${colour}`}>
            <div className="flex flex-column">
                <div className="flex">
                    <h4 className="flex-grow">
                        {message}
                        {messageTwo && <div>{messageTwo}</div>}
                    </h4>
                    <i className={`fa ${icon}`} />
                </div>
                {(setShow || url) && (
                    <div className="flex flex-center" style={{ marginTop: 'auto' }}>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                if (setShow) {
                                    setShow();
                                } else {
                                    history.push(url);
                                }

                                posthog.capture('todays-focus-clicked', { type: tileType });
                            }}
                        >
                            {SystemText(`PerformanceDashboard/Focus/${buttonText}`)}
                        </button>
                        {date && (
                            <span className="flex-grow text-right">
                                {SystemText('PerformanceDashboard/Focus/Due')} {e4Format(date, e4Formats.long)}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default withRouter(FocusTile);
